<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
	import {Message} from "element-ui";
    import router from "./router";
    import confing from '../configHttp.js'
    export default {

	    created() {
			
		this.$router.beforeEach((to, from, next) => {
			let title = document.getElementsByTagName('title')[0]
			 let favicon = document.getElementById("icon")
			var routearr=localStorage.getItem("routearr")

			if(to.path=="/authenticationYzm"||from.path=="/authenticationYzm"||to.path=="/authenticationRwm"||from.path=="/authenticationRwm"||to.path=="/login"||from.path=="/login"||from.path=="/register"||to.path=="/register" || to.path=="/portalLogin" || from.path=="/portalLogin"){
				next()
			}else{
                var useropj=localStorage.getItem("useropj");
                if (!useropj){
                    localStorage.clear();
                    router.push('/login');
                }
				if((routearr.indexOf(to.meta.roles[0]))==-1){
					 next(from.path);
				}else{
					next()
				}
			}
			
			if (confing.projectName == 'WGQ') {
				title.innerText = '电子专票'
				favicon.href="favicon.ico"
			} else {
				title.innerText = '税慧盟·销项平台'
				favicon.href="product.svg"
			}
		});
	    }
	};
</script>
<style lang="less">

	@import "./assets/css/flexall.less";
    @import "./assets/css/main.css";
    @import "./assets/css/color-dark.css";     /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>